<template>
  <div>
    <v-card width="480">
      <v-card-title>
        {{ isEditMode ? 'Edit' : 'New' }} Commission Type
      </v-card-title>
      <v-card-text v-if="formData">
        <v-text-field
          v-model="formData.Code"
          label="Code"
          :error-messages="errorMessages(vuelidate.formData.Code)"
          @blur="vuelidate.formData.Code.$touch()"
          dense
        />
        <v-text-field
          v-model="formData.Description"
          label="Description"
          :error-messages="errorMessages(vuelidate.formData.Description)"
          @blur="vuelidate.formData.Description.$touch()"
          dense
        />
        <v-text-field
          v-model="formData.SortOrder"
          label="Sort Order"
          type="number"
          :error-messages="errorMessages(vuelidate.formData.SortOrder)"
          @blur="vuelidate.formData.SortOrder.$touch()"
          dense
        />
        <v-checkbox v-model="formData.IsDeleted" label="Deleted" />
      </v-card-text>
      <v-card-actions
        ><v-btn color="success" class="ml-1" @click="saveClick">{{
          isEditMode ? 'Update' : 'Save'
        }}</v-btn>
        <v-btn color="error" class="ml-3" @click="cancelClick">Cancel</v-btn>
      </v-card-actions>
    </v-card>

    <DialogUtil ref="dialogUtil" />
  </div>
</template>

<script>
import { ref, watch } from 'vue'
import { host } from '@/services/HostAPI'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
export default {
  name: 'CommissionTypeEditor',
  props: {
    infoId: {
      type: String,
      default: null
    },
    isDialogOpen: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const dialogUtil = ref()

    const isEditMode = ref(false)
    const formData = ref()

    watch(
      () => props.isDialogOpen,
      newVal => {
        newVal && initDialog()
      }
    )

    const initDialog = async () => {
      isEditMode.value = props.infoId != null
      formData.value = isEditMode.value
        ? await loadCommissionType()
        : await initNewCommissionType()
      vuelidate.value.$reset()
    }

    const saveClick = async () => {
      if (validate()) {
        return
      }

      const result = isEditMode.value ? await update() : await saveNew()
      afterSaveOrUpdate(result)
    }

    const cancelClick = () => {
      context.emit('close')
    }

    const afterSaveOrUpdate = async result => {
      if (result.IsSuccess) {
        context.emit('update')
      } else {
        dialogUtil.value.inform({
          text: result.Message,
          snackbarTimeout: 10000,
          color: 'error'
        })
      }
    }

    const rules = {
      formData: {
        Code: { required },
        Description: { required },
        SortOrder: { required }
      }
    }

    const vuelidate = useVuelidate(rules, { formData })

    const errorMessages = item => {
      return vuelidate.value.$invalid ? item.$errors.map(e => e.$message) : []
    }

    const validate = () => {
      vuelidate.value.$touch()
      return vuelidate.value.$invalid
    }

    const loadCommissionType = async () => {
      const rq = { InfoId: props.infoId }
      const rs = await host.commissionType.retrieve(rq)
      return rs.Info
    }

    const saveNew = async () => {
      const rq = { Info: formData.value }
      const rs = await host.commissionType.create(rq)
      return rs
    }

    const update = async () => {
      const rq = { Info: formData.value }
      const rs = await host.commissionType.update(rq)
      return rs
    }

    const initNewCommissionType = async () => {
      const rq = { InfoId: props.infoId }
      const rs = await host.commissionType.newTemplate(rq)
      return rs.Info
    }

    initDialog()
    return {
      dialogUtil,
      isEditMode,
      formData,
      errorMessages,
      saveClick,
      cancelClick,
      vuelidate
    }
  }
}
</script>

<style lang="scss" scoped></style>
